<template>
    <components
        :is="selectable ? 'button' : 'div'"
        :class="cardClass"
        @click="toggleReview"
    >
        <span
            v-if="compact"
            :class="statusClass"
        >
        </span>
        <div class="RPReviewCard__content">
            <ReviewHeader
                :location="review.location"
                :review-id="review.id"
                :status="cardStatus"
                :compact="compact"
                @share="$emit('nav-to-url', review.share_url)"
                @request="$emit('nav-to-url', review.more_info_url)"
                @open-review="$emit('nav-to-url', review.review_url)"
            />
            <Body
                :review="review"
                :profile="review.profile"
                :status="cardStatus"
                :compact="compact"
                @nav-to-url="url => $emit('nav-to-url', url)"
                @nav-to-attributed="reviewId => $emit('nav-to-attributed', reviewId)"
            />
            <slot
                :reviewId="review.id"
                :siteName="review.profile.site.name"
                :responseCanBePostedDirectly="review.response_can_be_posted_directly"
                :reviewUrl="review.review_url"
            >
            </slot>
        </div>
    </components>
</template>
<script>
import stat from 'status/index';
import statusBuilder from 'status/statusBuilder';
import has from 'lodash/has';
import ReviewHeader from './ReviewCard/ReviewHeader.vue';
import Body from './ReviewCard/Body.vue';

export default {
    name: 'RPReviewCard',
    components: {
        ReviewHeader,
        Body,
    },
    props: {
        review: {
            type: Object,
            required: true,
            validator: (val) => {
                return has(val, 'id')
                    && has(val, 'rating')
                    && has(val, 'share_url')
                    && has(val, 'more_info_url')
                    && has(val, 'review_url')
                    && has(val, 'attributed_review_id')
                    && has(val, 'user_profile_image')
                    && has(val, 'review')
                    && has(val, 'reviewer')
                    && has(val, 'review_date')
                    && has(val, 'review_time')
                    && has(val, 'location')
                    && has(val, 'response_can_be_posted_directly')
                    && has(val.location, 'id')
                    && has(val.location, 'display_name')
                    && has(val.location, 'address_1')
                    && has(val.location, 'address_2')
                    && has(val.location, 'city')
                    && has(val.location, 'state')
                    && has(val.location, 'zip')
                    && has(val, 'profile')
                    && has(val.profile, 'id')
                    && has(val.profile, ['site', 'name']);
            },
        },

        //UI Modifiers
        isThreeStarsError: {
            type: Boolean,
            default: false
        },
        compact: {
            type: Boolean,
            default: false
        },
        feedMode: {
            type: Boolean,
            default: false
        },
        selectable: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
            default: stat.STANDBY
        }
    },
    data(){
        return{
            selected: false
        };
    },
    computed: {
        cardStatus(){
            if(this.status !== stat.STANDBY){
                return this.status;
            }
            switch(this.review.rating) {
            case 5:
            case 4:
                return stat.SUCCESS;
            case 3:
                return this.isThreeStarsError
                    ? stat.ERROR
                    : stat.WARNING;
            default:
                return stat.ERROR;
            }
        },
        cardClass(){
            return statusBuilder('RPReviewCard',
                this.cardStatus,
                false,
                {selected: this.selected},
            )
            ;
        },
        statusClass(){
            return statusBuilder(
                'RPReviewCard__status',
                this.cardStatus
            );
        }
    },
    mounted(){
        document.addEventListener('click', this.deselectReview);
    },
    destroyed(){
        document.removeEventListener('click', this.deselectReview);
    },
    methods: {
        deselectReview(e){
            if(!this.$el.contains(e.target)){
                this.selected = false;
            }
        },
        toggleReview(){
            if(this.selectable){
                if(this.selected || this.feedMode){
                    this.$emit('nav-to-review', {reviewId: this.review.id});
                }
                this.selected = !this.selected;
            }
        }
    }
};
</script>
<style lang="scss">
.RPReviewCard {
    background: $white;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
    display: flex;
    @include loading(100%, 100%);
    &--selected{
        background: $primary-50;
    }
    &__status {
        width: 0.25rem;
            height: 100%;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;

        &--saving { background-image: $gradient-purple; }
        &--success { background-image: $gradient-positive; }
        &--warning { background-image: $gradient-yellow; }
        &--error { background-image: $gradient-negative; }
    }
    &__content {
        width:100%;
    }
}
</style>

<docs>
```[import](./RPReviewCardExample.vue)
```
</docs>
